import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@icon/play-not-found.svg'


const _hoisted_1 = { class: "video-preview__embed" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "video-preview__broken"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "video-preview__broken-text" }, "Broken video link", -1)
const _hoisted_6 = {
  key: 3,
  class: "video-preview__loom-thumbnail",
  "aria-hidden": "true"
}
const _hoisted_7 = ["id", "data-plyr-provider", "data-plyr-embed-id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showLoomThumbnail)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.loomThumbnailUrl,
          alt: "Video preview",
          class: "video-preview__loom-thumbnail"
        }, null, 8, _hoisted_2))
      : (_ctx.showLoomIframe)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            src: _ctx.embedUrl,
            title: "Video preview",
            class: "video-preview__iframe",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen",
            allowfullscreen: ""
          }, null, 8, _hoisted_3))
        : (_ctx.showBrokenPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_icon, {
                data: _imports_0,
                width: "var(--icon-24)",
                height: "var(--icon-24)",
                color: "var(--monochrome05to04)"
              }),
              _hoisted_5
            ]))
          : (_ctx.isLoom)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : (_openBlock(), _createElementBlock("div", {
                key: 4,
                id: _ctx.videoId,
                "data-plyr-provider": _ctx.provider,
                "data-plyr-embed-id": _ctx.embedId
              }, null, 8, _hoisted_7)),
    (_ctx.showOverlay && !_ctx.showBrokenPreview)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "video-preview__overlay",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showVideo && _ctx.showVideo(...args)), ["prevent"]))
        }))
      : _createCommentVNode("", true)
  ]))
}